import React from 'react';

import { PropsWithChildren, useState } from 'react';
import { TargetContext } from './context';
import { IContentsModule } from 'types';

function TargetProvider({ children }: PropsWithChildren) {
  const [targetList, setTargetList] = useState<IContentsModule[]>([]);
  const [target, setTarget] = useState<IContentsModule | null>(null);

  return (
    <TargetContext.Provider
      value={{
        target,
        targetList,
        setTargetList,
        setTarget,
      }}
    >
      {children}
    </TargetContext.Provider>
  );
}

export { TargetProvider };
